// src/components/examples/CloudinaryTest.js
import React from 'react';

const CloudinaryTest = () => {
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h1 className="text-2xl font-bold text-blue-900 mb-2">🖼️ Cloudinary Configuration Test</h1>
        <p className="text-blue-700">
          This page tests if your Cloudinary environment variables are properly configured.
        </p>
      </div>

      {/* Configuration Status */}
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
        <h2 className="text-lg font-semibold mb-2">Environment Variables Status</h2>
        <div className="space-y-2 text-sm">
          <div className="flex items-center">
            <span className={`w-4 h-4 rounded-full mr-2 ${cloudName ? 'bg-green-500' : 'bg-red-500'}`}></span>
            <span>Cloud Name: {cloudName || 'Not set'}</span>
          </div>
          <div className="flex items-center">
            <span className={`w-4 h-4 rounded-full mr-2 ${uploadPreset ? 'bg-green-500' : 'bg-red-500'}`}></span>
            <span>Upload Preset: {uploadPreset || 'Not set'}</span>
          </div>
        </div>
        
        {(!cloudName || !uploadPreset) && (
          <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded">
            <p className="text-yellow-800 text-sm">
              ⚠️ Please set your Cloudinary environment variables in Vercel:
            </p>
            <code className="block mt-2 text-xs bg-yellow-100 p-2 rounded">
              REACT_APP_CLOUDINARY_CLOUD_NAME=your_cloud_name<br/>
              REACT_APP_CLOUDINARY_UPLOAD_PRESET=elderfit_images
            </code>
          </div>
        )}

        {(cloudName && uploadPreset) && (
          <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded">
            <p className="text-green-800 text-sm">
              ✅ Cloudinary environment variables are properly configured!
            </p>
          </div>
        )}
      </div>

      {/* Instructions */}
      <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
        <h3 className="text-lg font-semibold text-purple-900 mb-2">Next Steps</h3>
        <ol className="list-decimal list-inside space-y-1 text-sm text-purple-800">
          <li>If variables are not set, add them to your Vercel environment variables</li>
          <li>Make sure your Cloudinary account is set up with the correct upload preset</li>
          <li>Test image upload functionality in your app</li>
        </ol>
      </div>

      {/* Environment Info */}
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
        <h3 className="text-lg font-semibold mb-2">Environment Information</h3>
        <div className="text-sm space-y-1">
          <p><strong>NODE_ENV:</strong> {process.env.NODE_ENV}</p>
          <p><strong>Build Time:</strong> {new Date().toLocaleString()}</p>
        </div>
      </div>
    </div>
  );
};

export default CloudinaryTest; 